<template>
  <header class="app-header">
    <div class="container">
      <div class="logo">
        <img
          @click="tiaozhuanSy"
          style="height: 50px; margin-top: -20px; cursor: pointer"
          src="../../../assets/zdl-logo.png"
          alt=""
        />
      </div>

      <!-- <h3 style="width: 300px; color: #fff">辰阔数字科技有限公司</h3> -->
      <div class="Menu">
        <el-menu
          :default-active="dynaicIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <template v-for="item in category">
            <el-menu-item
              style="font-size: 18px"
              :key="item.id"
              :index="item.id"
              v-if="item.dataSon.length === 0"
              @click="tiaozhaunLy(item.linkUrl)"
            >
              <template slot="title" v-if="isExternal(item.linkUrl)">
                <el-link
                  type="primary"
                  :underline="false"
                  :target="item.target ? item.target : ''"
                  >{{ item.name }}
                </el-link>
              </template>
              <template
                slot="title"
                v-else-if="item.linkUrl !== null && item.linkUrl !== ''"
              >
                <router-link :to="item.linkUrl">{{ item.name }} </router-link>
              </template>
              <template v-else slot="title">
                <span @click="querymodelhandler(item.id)">{{ item.name }}</span>
              </template>
            </el-menu-item>

            <el-submenu
              :key="item.id"
              :index="item.id + ''"
              v-if="item.dataSon.length > 0"
            >
              <template slot="title">
                <span
                  @click="querymodelhandler(item.id)"
                  :class="item.id === activeIndex ? 'activeclickhandler' : ''"
                >
                  {{ item.name }}
                </span>
              </template>

              <el-menu-item
                v-for="sunItem in item.dataSon"
                :index="sunItem.id + ''"
                :key="sunItem.id"
              >
                <el-link
                  v-if="isExternal(sunItem.linkUrl)"
                  type="primary"
                  :underline="false"
                  :href="sunItem.linkUrl"
                  target="sunItem.target?sunItem.target:''"
                  >{{ sunItem.name }}
                </el-link>
                <router-link
                  v-else-if="sunItem.linkUrl !== null && sunItem.linkUrl !== ''"
                  :to="item.linkUrl"
                  >{{ item.name }}
                </router-link>
                <span v-else @click="querymodelhandler(sunItem.id)">
                  {{ sunItem.name }}</span
                >
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </div>

      <!-- <div class="search fr clearfix">
        <el-input
          placeholder="请输入搜索内容"
          size="small"
          suffix-icon="el-icon-search"
          clearable
          v-model="keyword"
        >
        </el-input>
      </div> -->
    </div>
  </header>
</template>
<script>
export default {
  name: "App-Header",
  data () {
    return {
      dynaicIndex: "1",
      keyword: "",
      activeMenu: 'home',

      category: [
        {
          "id": '1',
          "name": "首页",
          "linkUrl": '/home',
          path: 'home',
          "sort": 1,
          "dataSon": [],
        },
        {
          "id": '2',
          "name": "产品简介",
          "linkUrl": '/product',
          path: 'product',
          "sort": 3,
          "dataSon": [],
        },
        {
          "id": '3',
          // "linkUrl": "https://www.cecdlzx.com/dlzx/#/electric",
          "name": "信电查",
          "linkUrl": '/xdc',
          path: 'xdc',
          "sort": 4,
          "dataSon": [],
        },
        {
          "id": '4',
          // "linkUrl": "https://www.cecdlzx.com/dlzx/#/login",
          "name": "商务信用评价",
          "linkUrl": '/report',
          path: 'report',

          "sort": 5,
          "dataSon": [],
        },
        {
          "id": '5',
          // "linkUrl": "https://www.cecdlzx.com/dlzx/#/login",
          "name": "信用电力指数",
          "linkUrl": '/cecIndex',
          path: 'cecIndex',
          "sort": 7,
          "dataSon": [],
        },
        {
          "id": '6',
          // "linkUrl": "https://www.cecdlzx.com/dlzx/#/login",
          "name": "电力大数据",
          "linkUrl": '/monitor',
          path: 'monitor',
          "sort": 6,
          "dataSon": [],
        },
        {
          "id": '7',
          "name": "金融服务",
          "linkUrl": '/financial',
          path: 'financial',
          "sort": 8,
          "dataSon": [],
        },
        {
          "id": '8',
          "name": "联系我们",
          "linkUrl": '/contact',
          path: 'contact',
          "sort": 9,
          "dataSon": [],
        }
      ],
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
    },
    isExternal (path) {
      return /^(https?:|mailto:|tel:)/.test(path)
    },
    querymodelhandler (id) {

    },
    tiaozhaunLy (data) {
      this.$router.push(data).catch(err => { })
    },
    tiaozhuanSy () {
      this.$router.push('/home')
      location.reload()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.dynaicIndex = '1'
      this.activeMenu = window.location.hash.split("#")[1].split("/")[1]
      console.log(this.activeMenu)
      this.category.forEach((item) => {
        if (this.activeMenu == item.path) {
          this.dynaicIndex = item.id
        }
      })
    })
  },
}
</script>
<style scoped lang='less'>
.el-menu.el-menu--horizontal {
  border: none;
}

.app-header {
  background: #fff;
  position: relative;
  padding: 10px;

  .container {
    display: flex;
    align-items: center;
    border-bottom: solid 1px #e6e6e6;

    .search {
      margin-left: auto;
      /deep/ input {
        width: 200px;
        border-radius: 20px;
      }
    }
  }

  .logo {
    width: 200px;
    text-align: center;

    a {
      display: block;
      height: 132px;
      width: 100%;
      text-indent: -9999px;
      // background: url('@/assets/images/logo.png') no-repeat center 18px /
      // contain;
    }
  }

  .Menu {
    margin-left: 100px;
    margin-bottom: 30px;
  }
}
</style>
